export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "${str}": "",
        "Administracja": "",
        "Akceptuj": "",
        "Aktywne kanały komunikacji": "",
        "Anuluj": "",
        "Bazowy adres domenowy": "",
        "Błąd w kodzie MJML.": "",
        "Brak nowych powiadomień.": "",
        "Centrum powiadomień": "",
        "Data otrzymania": "",
        "Data utworzenia": "",
        "Data wysłania": "",
        "Dodaj szablon": "",
        "Dodaj wiadomość": "",
        "Dodane przez": "",
        "Domyślna stopka": "",
        "Domyślne logo": "",
        "Edytuj": "",
        "Edytuj komunikaty": "",
        "Edytuj szablon": "",
        "Edytuj wiadomość": "",
        "HTML": "",
        "Id": "",
        "ID": "",
        "Jest wymagany do prawidłowego osadzenia logo w treści wiadomości mailowej.": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "Kanał wymagany. Nie można go wyłączyć.": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Klucze": "",
        "Konfiguracja domyślna": "",
        "Kopiuj": "",
        "Link do pełnej dokumentacji": "",
        "Liquid": "",
        "Lista jest pusta": "",
        "MJML": "",
        "Moduł": "",
        "Moje szablony": "",
        "Nazwa": "",
        "Nazwa powiadomienia": "",
        "Nazwa szablonu": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się wykonać akcji": "",
        "Nie znaleziono żadnych wyników.": "",
        "Obsługiwane kanały": "",
        "Odznacz": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Poczta wychodząca": "",
        "Pod spodem": "",
        "Podgląd": "",
        "Podgląd i walidacja": "",
        "Położenie widoku podglądu": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdź akceptację": "",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienie niewidoczne.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie wymagane.": "",
        "Powiadomienie wymagane. Nie można go wyłączyć dla wymaganych kanałów.": "",
        "Powiadomienie zbiorowe zostało dodane.": "",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "",
        "Powrót": "",
        "Przywróć domyślne": "",
        "Skrócona dokumentacja": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "",
        "Status powiadomienia": "",
        "Status powiadomienia (włączone / wyłączone).": "",
        "Statusy": "",
        "Stopka oraz logo umieszczane są w powiadomieniach wysyłanych kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Strona główna": "",
        "System": "",
        "System powiadomień": "",
        "System szablonów wykorzystuje język Liquid do parsowania kontentu.": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony email": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Testuj": "",
        "Treść": "",
        "Typy powiadomień": "",
        "Tytuł": "",
        "Tytuł powiadomienia": "",
        "Ustawienia": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Usuń": "",
        "Wersje": "",
        "Widoczność w ustawieniach użytkownika.": "",
        "Włączone": "",
        "Włączony": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wszystko": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "wybierz...": "",
        "Wyłączone": "",
        "Wyłączony": "",
        "Wysyłaj tym kanałem": "",
        "Wysyłka wiadomości": "",
        "Wyślij do": "",
        "Z boku": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz ustawienia": "",
        "Zaznacz": "",
        "Zmiana hasła": "",
        "Zobacz wszystkie": ""
    }
};
